import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import {
  UPLOAD_STATE_PREPARING,
  UPLOAD_STATE_SCANNING,
  UPLOAD_STATE_TRANSFERRING
} from "./directUploadFile";

const intlMessages = defineMessages({
  preparing: {
    id: "uploader.step.preparing",
    defaultMessage: "Préparation de l'envoi..."
  },
  transferring: {
    id: "uploader.step.transferring",
    defaultMessage: "Envoi en cours..."
  },
  scanning: {
    id: "uploader.step.scanning",
    defaultMessage: "Analyse antivirus en cours, veuillez patienter..."
  }
});

// Returns a function that maps an UPLOAD_STATE_* step identifier to its translated
// label. Centralizes step wording so all upload contexts (Wysiwyg editors, file
// inputs, etc.) stay consistent without duplicating message definitions.
export const useUploadStepMessages = () => {
  const t = useFormatMessage();

  return stepId => {
    switch (stepId) {
      case UPLOAD_STATE_PREPARING:
        return t(intlMessages.preparing);
      case UPLOAD_STATE_TRANSFERRING:
        return t(intlMessages.transferring);
      case UPLOAD_STATE_SCANNING:
        return t(intlMessages.scanning);
      default:
        return null;
    }
  };
};
